import { useEffect, useState } from 'react'

import { wsClient, type WsStatus } from '@/lib/ws/client'

/**
 * Reactive hook that returns the current WebSocket connection status for the
 * given company. Re-renders whenever the status changes (connecting →
 * connected → disconnected → …).
 *
 * Returns `'disconnected'` immediately if `companyId` is null.
 */
export function useWsStatus(companyId: string | null): WsStatus {
  const [status, setStatus] = useState<WsStatus>(
    companyId ? wsClient.getStatus(companyId) : 'disconnected',
  )

  useEffect(() => {
    if (!companyId) {
      setStatus('disconnected')
      return
    }
    const { currentStatus, unsubscribe } = wsClient.subscribeStatus(
      companyId,
      setStatus,
    )
    setStatus(currentStatus)
    return unsubscribe
  }, [companyId])

  return status
}
